const React = require("react");
const PropTypes = require("prop-types");
const ProgressBar = require("components/ui/ProgressBar");

const Header = ({ title, progress }) => {
  return (
    <div className="b-inquiry-modal__header">
      {title && (
        <div className="b-inquiry-modal__header__title">
          <h1>{I18n.t("alert_modal.header.title", { title })}</h1>
        </div>
      )}
      {progress && <ProgressBar progress={progress} />}
    </div>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  progress: PropTypes.number,
};

Header.defaultProps = {
  title: null,
  progress: null,
};

module.exports = Header;
